import { getConsumer } from './consumer';

export function subscribeToInbox(callbacks = {}) {
  const consumer = getConsumer();

  return consumer.subscriptions.create(
    { channel: 'Chat::UserInboxChannel' },
    {
      connected() {
        if (callbacks.onConnected) callbacks.onConnected();
      },

      disconnected() {
        if (callbacks.onDisconnected) callbacks.onDisconnected();
      },

      received(data) {
        if (data.type === 'new_message' && callbacks.onMessage) {
          callbacks.onMessage(data.conversation_id, data.message);
        } else if (data.type === 'message_deleted' && callbacks.onMessageDeleted) {
          callbacks.onMessageDeleted(data.conversation_id, data.message_id);
        } else if (data.type === 'message_edited' && callbacks.onMessageEdited) {
          callbacks.onMessageEdited(data.conversation_id, data.message);
        } else if (data.type === 'member_added' && callbacks.onMemberAdded) {
          callbacks.onMemberAdded(data.conversation_id);
        } else if (data.type === 'member_removed' && callbacks.onMemberRemoved) {
          callbacks.onMemberRemoved(data.conversation_id);
        } else if (data.type === 'user_blocked' && callbacks.onUserBlocked) {
          callbacks.onUserBlocked(data.conversation_id);
        } else if (data.type === 'user_unblocked' && callbacks.onUserUnblocked) {
          callbacks.onUserUnblocked(data.conversation_id);
        } else if (data.type === 'contact_blocked' && callbacks.onContactBlocked) {
          callbacks.onContactBlocked(data.conversation_id, data.blocked_id);
        } else if (data.type === 'contact_unblocked' && callbacks.onContactUnblocked) {
          callbacks.onContactUnblocked(data.conversation_id, data.blocked_id);
        } else if (data.type === 'conversation_deactivated' && callbacks.onConversationDeactivated) {
          callbacks.onConversationDeactivated(data.conversation_id);
        } else if (data.type === 'conversation_reactivated' && callbacks.onConversationReactivated) {
          callbacks.onConversationReactivated(data.conversation_id);
        } else if (data.type === 'unread_notification_count' && callbacks.onUnreadNotificationCount) {
          callbacks.onUnreadNotificationCount(data.count);
        } else if (data.type === 'unread_chat_count' && callbacks.onUnreadChatCount) {
          callbacks.onUnreadChatCount(data.count);
        } else if (data.type === 'conversation_hidden' && callbacks.onConversationHidden) {
          callbacks.onConversationHidden(data.conversation_id);
        } else if (data.type === 'conversation_unhidden' && callbacks.onConversationUnhidden) {
          callbacks.onConversationUnhidden(data.conversation_id);
        }
      }
    }
  );
}
